module.exports = __webpack_public_path__ + "assets/img/block-left-hover-c0e100b4.png";